<div [id]="model.id" class="popup w-100 {{ size }}">
  <!-- TODO add type for icon / color -->
  <div [ngClass]="model.iconColorClass ? model.iconColorClass : 'blue'" class="button small text-white" style="pointer-events: none">
    <i [className]="model.iconTypeClass ? 'fas ' + model.iconTypeClass : 'fas fa-bell'" aria-hidden="true" class="far"></i>
  </div>
  <div class="popup-inner">
    <h3 [translate]="model.titleKey" data-test="popup-title" id="mwe_popup-title"></h3>
    @if (model.messageKey) {
      <p [innerHTML]="model.messageKey | translate" data-test="popup-message"></p>
    }
    @if (model.formModel) {
      <mwe-form (formSubmitted)="submit()" [formModel]="model.formModel" />
    }
    <div class="mt-3">
      @if (model.showSubmitButton) {
        <mwe-button-link (clicked)="submit()" [label]="model.submitButtonKey" dataTest="popup-submit-link" />
      }
    </div>

    <div class="mt-3 mb-3">
      @if (model.showCancelButton) {
        <mwe-button-link
          (clicked)="cancel()"
          [label]="model.cancelButtonKey"
          [url]="model.cancelButtonHref"
          color="blue"
          dataTest="popup-cancel-link"
        />
      }
    </div>

    @if (model.showAdditionalButtons) {
      <div class="mb-3">
        @for (button of model.additionalButtons; track button; let idx = $index) {
          <span>
            <mwe-button-link
              (clicked)="clickAdditionalButton(getAdditionalButtonId(button.buttonId, idx?.toString()))"
              [btnId]="getAdditionalButtonId(button.buttonId, idx?.toString())"
              [dataTest]="'popup-additional-link-' + idx"
              [label]="button.buttonKey"
              [url]="button.buttonHref"
              color="blue"
            />
          </span>
        }
      </div>
    }
    <div #testAnchorElementFeedback></div>
  </div>
</div>
